import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import calendar from 'dayjs/plugin/calendar.js';
import 'dayjs/locale/en.js';

// 🔌 Plugin 연결
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(calendar);

/**
 * @param {string|number|Date} date - 기준 시간
 * @param {string} tz - IANA timezone (ex: 'Asia/Seoul')
 */
function relativeTimeString(date, tz = 'UTC') {
    const now = dayjs().tz(tz);
    const localTime = dayjs(date).tz(tz);

    const diffMinutes = now.diff(localTime, 'minute');
    const diffHours = now.diff(localTime, 'hour');
    const diffDays = now.diff(localTime, 'day');
    const diffWeeks = now.diff(localTime, 'week');

    if (diffMinutes < 1) return 'Now';
    if (diffMinutes < 60) return `${diffMinutes}m`;
    if (diffHours < 24) return `${diffHours}h`;
    if (diffDays < 7) return `${diffDays}d`;
    if (diffWeeks < 4) return `${diffWeeks}w`;

    return localTime.format('MMM D');
}

function getLocalTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || dayjs.tz.guess() || 'UTC';
}

function relativeTooltipString(date) {
    const tz = getLocalTimeZone();
    const now = dayjs().tz(tz);
    const localTime = dayjs(date).tz(tz);

    return localTime.calendar(now, {
        sameDay: '[Today] HH:mm',
        lastDay: '[Yesterday] HH:mm',
        lastWeek: 'MMM D HH:mm',
        sameElse: 'MMM D HH:mm',
    });
}

function relativeChatDateDividerString(date) {
    const tz = getLocalTimeZone();
    const now = dayjs().tz(tz);
    const localTime = dayjs(date).tz(tz);

    return localTime.calendar(now, {
        sameDay: '[Today]', // []로 감싸면 포맷팅되지 않고 그대로 출력됨
        lastDay: '[Yesterday]',
        nextDay: '[Tomorrow]', // (채팅에선 거의 안 쓰이지만 기본값 방어)
        lastWeek: 'MMM D', // 이번 주 내의 과거
        sameElse: 'YYYY MMM D', // 아주 오래된 과거 (연도 포함)
    });
}

function localTimeString(date, tz = 'UTC') {
    const now = dayjs().tz(tz);
    const localTime = dayjs(date).tz(tz);
    return localTime.format('YYYY-MM-DD HH:mm');
}

function printElapsed(start) {
    let elapsed = Date.now() - start;
    return `${numberWithCommas(elapsed)}ms`;

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}

export { relativeTimeString, relativeTooltipString, relativeChatDateDividerString, localTimeString, printElapsed };
